export default {"src":"/_next/static/media/arrow-right-14px-mutedBlue.74577f59.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};